import Delegate from 'ftdomdelegate'

import Accessibility from "../tools/accessibility";

export default class SearchBar {
  constructor() {
    this.documentDelegate = new Delegate(document.body);

    this.searchElement = document.getElementById('search');
    this.searchInputElement = this.searchElement.querySelector('[name="q"]');
    this.searchResultsElement = this.searchElement.querySelector('.search__results');
    this.queryMap = {};
    this.isOpen = false;

    this.pageOverlayElement = document.querySelector('.pageOverlay');

    this._attachListeners();
  }

  destroy() {
    this.searchInputElement.removeEventListener('keydown', this._preventSubmissionListener);
    this.searchInputElement.removeEventListener('input', this._onInputListener);

    this.documentDelegate.off();
  }
  _attachListeners() {
    this._preventSubmissionListener = this._preventSubmission.bind(this);
    this._onInputListener = this._debounce(this._onInput.bind(this), 250);

    this.searchInputElement.addEventListener('keydown', this._preventSubmissionListener);
    this.searchInputElement.addEventListener('input', this._onInputListener);

    this.documentDelegate.on('click', '[data-action="toggle-search"]', this._toggleSearch.bind(this));
    this.documentDelegate.on('click', '[data-action="open-search"]', this._openSearch.bind(this));
    this.documentDelegate.on('click', '[data-action="close-search"]', this._closeSearch.bind(this));
  }

  /**
   * Toggle the search
   */

  _toggleSearch(event) {
    if (this.isOpen) {
      this._closeSearch(event);
    } else {
      this._openSearch(event);
    }

    event.preventDefault();
  }

  /**
   * Open the search form and trap focus
   */

  _openSearch() {
    var _this17 = this;

    this.searchElement.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('no-scroll');
    Accessibility.trapFocus(this.searchElement, 'search', this.searchElement.querySelector('[name="q"]'));

    var onFocusListener = function onFocusListener() {
      _this17.searchInputElement.focus();
      _this17.searchElement.removeEventListener('transitionend', onFocusListener);
    };

    this.searchElement.addEventListener('transitionend', onFocusListener);
    this.isOpen = true;

    this.pageOverlayElement.classList.add('is-visible');
    document.querySelector('#shopify-section-header').style.zIndex = 10;
  }

  /**
   * Close the search form and clear focus
   */

  _closeSearch() {
    var _this18 = this;

    this.searchElement.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove('no-scroll');
    Accessibility.removeTrapFocus(this.searchElement, 'search');

    this.isOpen = false;

    var onTransitionEnd = function onTransitionEnd(event) {
      if (event.propertyName === 'visibility') {
        document.querySelector('#shopify-section-header').style.zIndex = '';
        _this18.pageOverlayElement.removeEventListener('transitionend', onTransitionEnd);
      }
    };

    this.pageOverlayElement.addEventListener('transitionend', onTransitionEnd);
    this.pageOverlayElement.classList.remove('is-visible');
  }

  /**
   * In order to prevent an odd UX where hitting the enter always choose the product results, if the search is set to product + something else,
   * then we disable submission using enter key
   */

  _preventSubmission(event) {
    if (event.keyCode === 13 && window.theme.searchMode !== 'product') {
      event.preventDefault();
    }
  }

  /**
   * This is called when the user has stopped typing (after debounce delay)
   */

  _onInput(event) {
    var _this19 = this;

    if (event.keyCode === 13) {
      return;
    }

    // Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
    // keep track of sent requests, and only use the results of the last one
    this.lastInputValue = event.target.value;

    if (this.lastInputValue === '') {
      this._resetSearch();
      return;
    }

    var queryOptions = { method: 'GET', credentials: 'same-origin' };

    var queries = [fetch('/search?view=ajax&q=' + encodeURIComponent(this.lastInputValue) + '*&type=product', queryOptions)];

    if (window.theme.searchMode !== 'product') {
      queries.push(fetch('/search?view=ajax&q=' + encodeURIComponent(this.lastInputValue) + '*&type=' + window.theme.searchMode.replace('product,', ''), queryOptions));
    }

    this.queryMap[this.lastInputValue] = true;

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    Promise.all(queries).then(function (responses) {
      // If we receive the result for a query that is not the last one, we simply do not process the result
      if (_this19.lastInputValue !== event.target.value) {
        return;
      }

      delete _this19.queryMap[event.target.value];

      Promise.all(responses.map(function (response) {
        return response.text();
      })).then(function (contents) {
        // If we have only one content then we only have product, otherwise we have products and articles
        if (window.theme.searchMode === 'product') {
          _this19.searchResultsElement.innerHTML = contents[0];
        } else {
          _this19.searchResultsElement.innerHTML = '<div class="pageLayout pageLayout--breakLap">\n              <div class="pageLayout__section">' + contents[0] + '</div>\n              <div class="pageLayout__section pageLayout__section--secondary">' + contents[1] + '</div>\n            </div>';
        }

        _this19.searchResultsElement.setAttribute('aria-hidden', 'false');
      });

      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
  }
  _resetSearch() {
    if (window.theme.searchMode === 'product') {
      this.searchResultsElement.innerHTML = '';
    } else {
      this.searchResultsElement.innerHTML = '<div class="pageLayout pageLayout--breakLap">\n              <div class="pageLayout__section"></div>\n              <div class="pageLayout__section pageLayout__section--secondary"></div>\n            </div>';
    }

    this.searchResultsElement.setAttribute('aria-hidden', 'true');

    document.dispatchEvent(new CustomEvent('theme:loading:end')); // Just in case
  }

  /**
   * Simple function that allows to debounce
   */

  _debounce(fn, delay) {
    var _this20 = this;

    var timer = null;

    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this20, args);
      }, delay);
    };
  }
}